/**
 * 스크롤에 따라 헤더 높이를 줄이는 상태 — Alpine 컴포넌트.
 *
 * 높이 자체는 CSS 변수 --site-header-height 하나가 정하고, 여기서는
 * 문서 최상위에 data-scrolled 만 표시한다. 그래야 헤더뿐 아니라 이 변수를 쓰는
 * 다른 자리(앵커 여백, /setup/ 퀵 네비 sticky 기준)도 함께 따라온다.
 *
 * <header class="site-header" x-data="header">
 */

// 이 정도 내려가면 '스크롤 중'으로 본다. 살짝 튕기는 스크롤에 헤더가 떨리지 않을 만큼.
const THRESHOLD = 24;

const header = () => ({
  init() {
    const sync = () => {
      document.documentElement.dataset.scrolled = window.scrollY > THRESHOLD ? 'true' : 'false';
    };

    sync();
    window.addEventListener('scroll', sync, { passive: true });
  },
});

export default header;
